import { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { X } from "lucide-react";

export default function CameraScanner({ onClose, onDetected, notify, embed = false, continuous = false, elementId = "gempar-camera-reader" }) {
  const lastRef = useRef({ code: "", at: 0 });
  useEffect(() => {
    const scanner = new Html5Qrcode(elementId);
    const safeStop = () => {
      try {
        const state = scanner.getState();
        if (state === 2) scanner.stop().catch(() => {});
      } catch (error) {}
    };
    scanner.start(
      { facingMode: "environment" },
      { fps: 10, qrbox: { width: 280, height: 160 } },
      code => {
        const now = Date.now();
        // De-duplicate: same code within 1.5s ignored
        if (lastRef.current.code === code && now - lastRef.current.at < 1500) return;
        lastRef.current = { code, at: now };
        onDetected(code);
        if (!continuous) safeStop();
      },
      () => {},
    ).catch(() => { notify("Kamera izni verilmedi veya kamera kullanılamıyor"); onClose(); });
    return safeStop;
  }, [notify, onClose, onDetected, continuous, elementId]);

  if (embed) {
    return <div className="camera-embed"><div data-testid="camera-video" id={elementId} className="camera-video-embed"/><p data-testid="camera-status" className="camera-hint">Barkodu kameraya tutun</p></div>;
  }
  return <div className="overlay"><div className="scanner-modal"><div className="modal-head"><h3>Barkod tara</h3><button data-testid="camera-close-button" className="icon-button" onClick={onClose}><X size={19}/></button></div><div data-testid="camera-video" id={elementId} className="camera-video"/><p data-testid="camera-status" className="muted">Barkodu kameranın ortasına tutun.</p></div></div>;
}
